module.exports = __webpack_public_path__ + "img/colored_circles-4-mob.a22ffbb3.png";